import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10.2 3.333A6.67 6.67 0 0 0 3.534 10a6.67 6.67 0 0 0 6.666 6.667A6.67 6.67 0 0 0 16.867 10 6.669 6.669 0 0 0 10.2 3.333Z" stroke="currentColor" stroke-width="1.5" /> <path d="M10.2 6.667a3.335 3.335 0 0 0 0 6.666 3.335 3.335 0 0 0 0-6.666Z" fill="currentColor" />' }
  })
);